import React from 'react';
import SearchForProposalStatus from '../components/ProposalStatusNew/SearchForProposalStatus';
import '../assets/css/proposal_status_new.css';


const ProposalStatusPageNew = () => {

  return (
    <div>
      <SearchForProposalStatus />
    </div>
  );
};

export default ProposalStatusPageNew;


/** WEBPACK FOOTER **
 ** ./src/containers/ProposalStatusPageNew.js
 **/